export const environment = {
  production: true,
  proxyApiUrl: '',
};
